import VueRouter from 'vue-router';

// Home View Components
import nxsDashboard from './components/home/dashboard/Dashboard.vue';
import nxsUsers from './components/home/users/Users.vue';
import nxsUserList from './components/home/users/UserList.vue';
import nxsUserDetail from './components/home/users/UserDetail.vue';
import nxsAttendance from './components/home/attendance/Attendance.vue';
import nxsAttendanceDetail from './components/home/attendance/AttendanceDetail.vue';
import nxsObjectives from './components/admin/ObjectiveChart.vue';
import nxsUpdates from './components/home/updates/Updates.vue';
import nxsUpdateList from './components/home/updates/UpdateLists.vue';
import nxsUpdateDetail from './components/shared/updates/UpdateDetail.vue';
import nxsInventory from './components/home/Inventory.vue';

// Admin View Components
import nxsAdminDashboard from './components/admin/dashboard/Dashboard.vue';
import nxsAdminEvents from './components/admin/events/Events.vue';
import nxsAdminEventCard from './components/admin/events/EventTypeCard.vue';
import nxsAdminEventDetail from './components/admin/events/EventDetail.vue';
import nxsAdminUpdates from './components/admin/updates/Updates.vue';
import nxsAdminUpdateList from './components/admin/updates/UpdateList.vue';
import nxsAdminObjectives from './components/admin/ObjectiveManagement.vue';
import nxsAdminAudits from './components/admin/Audits.vue';
import nxsAdminDisputes from './components/admin/disputes/Disputes.vue';
import nxsAdminDisputesSubmitted from './components/admin/disputes/DisputesSubmitted.vue';
import nxsAdminDisputesFinalized from './components/admin/disputes/DisputesFinalized.vue';
import nxsAdminDisputesResolved from './components/admin/disputes/DisputesResolved.vue';
import nxsAdminOrg from './components/admin/org/Organization.vue';
import nxsAdminOrgUsers from './components/admin/org/Users.vue';
import nxsAdminOrgPositions from './components/admin/org/Positions.vue';
import nxsAdminOrgUnits from './components/admin/org/Units.vue';
import nxsAdminOrgRanks from './components/admin/org/Ranks.vue';
import nxsAdminInventory from './components/admin/inventory/Inventory.vue';
import nxsAdminInventoryItems from "./components/admin/inventory/Items.vue";
import nxsAdminInventoryApprovals from "./components/admin/inventory/Approvals.vue";
import nxsAdminInventoryRequests from "./components/admin/inventory/Requests.vue";
import nxsAdminInventoryUsers from "./components/admin/inventory/Users.vue";
import nxsAdminAbout from './components/admin/About.vue';
import nxsAdminSettings from './components/admin/settings/Settings.vue';

// Vue Router
const routes = [
    {path: '/', redirect: '/home'},
    {path: '/home', component: nxsDashboard, name: 'HomeDashboard'},
    {
        path: '/home/users', component: nxsUsers,
        children: [
            {path: '', component: nxsUserList},
            {path: ':userId', component: nxsUserDetail, props: true}
        ]
    },
    {path: '/home/disputes', redirect: '/home/attendance'},
    {
        path: '/home/attendance', component: nxsAttendance,
        children: [
            {path: ':eventTypeId', component: nxsAttendanceDetail, props: true}
        ]
    },
    {path: '/home/objectives', component: nxsObjectives, name: 'HomeObjectives'},
    {
        path: '/home/updates', component: nxsUpdates, children: [
            {path: '', component: nxsUpdateList},
            {path: ':id', component: nxsUpdateDetail, props: true}
        ]
    },
    {path: '/home/inventory', component: nxsInventory, name: 'HomeInventory'},

    {path: '/admin', component: nxsAdminDashboard, name: 'AdminDashboard'},
    {path: '/admin/about', component: nxsAdminAbout, name: 'AdminAbout'},
    {path: '/admin/audits', component: nxsAdminAudits, name: 'AdminAudits'},
    {
        path: '/admin/eventsbytype', component: nxsAdminEvents, name: 'AdminEvents',
        children: [
            {path: ':eventTypeId', component: nxsAdminEventCard, props: true}
        ]
    },
    {path: '/admin/event/:eventId', component: nxsAdminEventDetail, props: true},
    {
        path: '/admin/updates', component: nxsAdminUpdates, name: 'AdminUpdates',
        children: [
            {path: '', component: nxsAdminUpdateList},
            {path: ':id', component: nxsUpdateDetail, props: true}
        ]
    },
    {path: '/admin/objectives', component: nxsAdminObjectives, name: 'AdminObjectives'},
    {
        path: '/admin/disputes', component: nxsAdminDisputes,
        children: [
            {path: 'submitted', component: nxsAdminDisputesSubmitted},
            {path: 'finalized', component: nxsAdminDisputesFinalized},
            {path: 'resolved', component: nxsAdminDisputesResolved}
        ]
    },
    {
        path: '/admin/inventory', component: nxsAdminInventory,
        children: [
            {path: 'users', component: nxsAdminInventoryUsers},
            {path: 'approvals', component: nxsAdminInventoryApprovals},
            {path: 'items', component: nxsAdminInventoryItems},
            {path: 'requests', component: nxsAdminInventoryRequests}
        ]
    },
    {
        path: '/admin/organization', component: nxsAdminOrg,
        children: [
            {path: 'users', component: nxsAdminOrgUsers},
            {path: 'positions', component: nxsAdminOrgPositions},
            {path: 'units', component: nxsAdminOrgUnits},
            {path: 'ranks', component: nxsAdminOrgRanks}
        ]
    },
    {path: '/admin/settings', component: nxsAdminSettings, name: 'AdminSettings'}
];

export default new VueRouter({
    routes,
    base: '/',
    mode: 'history',
    history: true
})

